import { Alert, Button, Col, Form, Input, Modal, Row, Table, Tooltip } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';

function AssetCategory() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [form] = Form.useForm();
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'desc',
            columnKey: 'asset_category_id',
        }
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const titlePage = 'Asset Category Data';

    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            render: (id, record, index) => {
                ++index;
                return (page.pagination.current - 1) * page.pagination.pageSize + index;
            },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
        },
        {
            title: 'Description',
            dataIndex: 'desc',
            key: 'desc',
            render: (text) => text || '-',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Tooltip title="Edit">
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <EditOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </>
            ),
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order === 'ascend' ? 'asc' : 'desc';
        const columnKey = page.sorter?.columnKey || 'asset_category_id';
        getApi('GET', `/asset-categories?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`);
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };

        apiCall(dataReq).then((res) => {
            if (res.status === 'success') {
                setData(res.data.data);
                setPage(prev => ({
                    ...prev,
                    pagination: {
                        ...prev.pagination,
                        total: res.data.total_data
                    }
                }));
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        });
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method,
            url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };

        await apiCall(dataReq).then((res) => {
            if (res.status === 'success') {
                setdataModal(null);
                setIsModal(false);
                setIsAlert(true);
                setTextAlert(res.message);
                form.resetFields();
            } else {
                modalError(res.message);
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        });
    };

    const modalDeleteData = (v) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this data?',
            onOk: () => postApi('DELETE', '/asset-categories/' + v.asset_category_id, null),
        });
    };

    const openModal = (type, data) => {
        if (type === 'edit' && data) {
            setdataModal(data);
            form.setFieldsValue({
                name: data.name,
                desc: data.desc,
            });
        } else {
            setdataModal(null);
            form.resetFields();
        }
        setIsModal(true);
    };

    const onFinish = (ev) => {
        if (dataModal) {
            postApi('PUT', '/asset-categories/' + dataModal.asset_category_id, ev);
        } else {
            postApi('POST', '/asset-categories', ev);
        }
    };

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);
        form.resetFields();
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    };

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Asset Category</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => openModal('add', null)}>
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                rowKey={(record) => record.asset_category_id}
            />
            <Modal title="Asset Category Data" open={isModal} onOk={form.submit} onCancel={closeModal} okText="Save">
                <Form form={form} name="form" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="name"
                        label="Category Name"
                        rules={[{ required: true, message: 'Category Name is required!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="desc"
                        label="Description"
                        rules={[{ required: false }]}
                    >
                        <Input.TextArea rows={4} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default AssetCategory;
